import {HoistService, InitContext, XH} from '@xh/hoist/core';
import {PerformanceCalcData, PerformanceChartData, RiskAnalytics, RiskWindow, YoyReturnData} from '../data/DataTypes';
import {getDefaultOptions} from '../../core/ServiceUtils';
import {runInAction} from '@xh/hoist/mobx';

export class PerformanceService extends HoistService {
    performanceChartData: PerformanceChartData;
    calcData: PerformanceCalcData;

    override async initAsync(ctx: InitContext): Promise<void> {
        console.log('initializing PerformanceSerivce');
        const [chartData, calcData] = await Promise.all([this.fetchPerformanceChartDataAsync(), this.fetchCalcDataAsync()]);
        runInAction(() => {
            this.performanceChartData = chartData;
            this.calcData = calcData;
        });
    }

    /** Performance of one portfolio, or of all the non-cash portfolios when portfolioId is null. */
    async fetchCalcDataAsync(portfolioId: number = null): Promise<PerformanceCalcData> {
        return XH.fetchService.getJson({
            url: `${XH.getConf('svcApiUrl')}/performance`,
            params: portfolioId != null ? {portfolioId} : null,
            ...getDefaultOptions()
        });
    }

    /** Risk analytics of one portfolio, or of all the non-cash portfolios added up when portfolioId is null. */
    async fetchRiskAnalyticsAsync(portfolioId: number, window: RiskWindow): Promise<RiskAnalytics> {
        return XH.fetchService.getJson({
            url: `${XH.getConf('svcApiUrl')}/performance/risk`,
            params: portfolioId != null ? {portfolioId, window} : {window},
            ...getDefaultOptions()
        });
    }

    async fetchPerformanceChartDataAsync(): Promise<PerformanceChartData> {
        return XH.fetchService.getJson({
            url: `${XH.getConf('svcApiUrl')}/performance/historic`,
            ...getDefaultOptions()
        });
    }

    async fetchYoOYReturnsAsync(): Promise<YoyReturnData[]> {
        const data = await XH.fetchService.getJson({
            url: `${XH.getConf('svcApiUrl')}/performance/yoyreturns`,
            ...getDefaultOptions()
        });
        return data;
    }
}
